import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ACTIONS_MENU_OPENED_LOCATIONS } from './useTrackAgentActionsMenuOpened.meta';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The user opens the Saved skills list in the composer Actions menu',
  name: 'agent_actions_menu_skills_opened',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Which Actions menu entry surface opened Saved skills (composer Actions button or zero-state chip)',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_ACTIONS_MENU_OPENED_LOCATIONS],
    },
  ],
};

export default META;
